import { columns } from "@/components/tables/items/columns";
import { DataTable } from "@/components/tables/items/table";
import { httpClient } from "@/lib/http-client";
import { HydrationBoundary, keepPreviousData, useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useTranslation } from "@/lib/paraglide-react";
interface PaginatedResponse<T> {
  data: T[];
  total: number;
}
import { Route } from "/app/src/routes/{-$locale}/builds/$id/items.tsx";
function ItemsPage() {
  const {
    t
  } = useTranslation();
  const {
    id
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  const [page, setPage] = useState({
    pageIndex: 0,
    pageSize: 25
  });
  const [filters, setFilters] = useState<ColumnFiltersState>([]);
  const {
    data: items
  } = useQuery({
    queryKey: ["build-items", {
      id,
      page,
      filters
    }],
    queryFn: () => {
      const params = new URLSearchParams({
        page: (page.pageIndex + 1).toString(),
        limit: page.pageSize.toString()
      });

      // Add filters to params
      for (const filter of filters) {
        params.append(filter.id, filter.value as string);
      }
      return httpClient.get<PaginatedResponse<SingleItem>>(`/builds/${id}/items?${params.toString()}`);
    },
    placeholderData: keepPreviousData
  });
  return <main className="flex flex-col items-start justify-start h-full gap-1 px-4 w-full">
      <p className="text-lg font-semibold">{t("builds.items.title")}</p>
      <DataTable columns={columns} data={items?.data ?? []} page={page} setPage={setPage} total={items?.total ?? 0} filters={filters} setFilters={setFilters} />
    </main>;
}
const SplitComponent = () => {
  const {
    dehydratedState
  } = Route.useLoaderData() as {
    dehydratedState: DehydratedState;
    id: string;
  };
  return <HydrationBoundary state={dehydratedState}>
        <ItemsPage />
      </HydrationBoundary>;
};
export { SplitComponent as component };